import * as React from 'react';

import * as styles from './styles';
import {
  ContainerDefault,
  DescriptionTitle,
  Dropdown,
  HoverButton,
  type PlacementType,
  RadioButton,
  SortMenuAscIcon,
} from '..';
import RadioGroup from '@material-ui/core/RadioGroup';

export interface Option<T> {
  value: T;
  key: string;
}

export interface SortProps<T> {
  buttonTitle?: string;
  title?: string;
  options: Array<Option<T>>;
  initialSelectedOption?: Option<T>;
  onChange: (option: Option<T>) => void;
  placement?: PlacementType;
  className?: string;
}

export interface SortState<T> {
  selected: Option<T> | undefined;
  hovered: boolean;
  firstTime: boolean;
}

export class Sort<T> extends React.Component<SortProps<T>, SortState<T>> {
  constructor(props: SortProps<T>) {
    super(props);

    this.state = {
      firstTime: true,
      selected: props.initialSelectedOption,
      hovered: false,
    };
  }

  private onHoverChange = (hovered: boolean) => {
    this.setState({ hovered });
  };

  private handleChange = (selected: Option<T>) => {
    this.setState({ selected, firstTime: false }, () =>
      this.props.onChange(selected)
    );
  };

  private getButtonTitle = () => {
    if (!this.props.buttonTitle) return null;

    if (this.state.firstTime) {
      return this.props.buttonTitle;
    }
    if (this.state.selected) {
      return this.state.selected.key;
    }
  };

  private getOverlay = () => (
    <ContainerDefault className={styles.overlay}>
      {this.props.title && (
        <DescriptionTitle className={styles.title}>
          {this.props.title}
        </DescriptionTitle>
      )}
      <RadioGroup value={this.state.selected?.value}>
        {this.props.options.map((option) => (
          <RadioButton
            key={option.key}
            className={styles.radioButton}
            onChange={() => this.handleChange(option)}
            value={option.value}
            label={option.key}
          />
        ))}
      </RadioGroup>
    </ContainerDefault>
  );

  public render() {
    const { placement, className = '', buttonTitle } = this.props;
    return (
      <Dropdown
        trigger='hover'
        overlay={this.getOverlay}
        onHoverChange={this.onHoverChange}
        placement={placement}
      >
        <div className={className}>
          <HoverButton hovered={this.state.hovered}>
            <SortMenuAscIcon
              className={buttonTitle ? styles.icon : undefined}
            />
            {this.getButtonTitle()}
          </HoverButton>
        </div>
      </Dropdown>
    );
  }
}
